import $ from 'jquery'

const AboutMeSec = ({ cvInfo }) => {
    // console.log(cvInfo)

    const openContact = () => {
        $(".animated-section").removeClass("section-active");
        $(".contact").addClass("section-active");
        $(".contact").addClass("custom-anim");
    }

    return (

        <div className="about-me-sec">
            <div className="row">
                <div className="col-md-6">
                    <div className="about-tx">
                        <h4 className="sub-title">{cvInfo.title1}</h4>
                        <h2 className="title">{cvInfo.title2}</h2>
                        <p className="description">
                            {cvInfo.summary}
                        </p>
                        <a href={`https://amirsabet.ir/amirsabet_resume.pdf`} className="btn-page ms-2">دانلود رزومه</a>
                        <div className="btn-page btn-withe" onClick={() => openContact()}>ارتباط با ما</div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="me-photo">
                        <div className="hp-inner" style={{ backgroundImage: `url(https://amirsabit.4api.ir/uploads/Admin/Image/${cvInfo?.image_main})` }} ></div>
                        {/* <div className="hp-inner" ></div> */}
                    </div>
                </div>
            </div>
        </div>

    )
}
export default AboutMeSec;